import KEYS from '@/values/keys';

export const USER_REQUESTS_STORE_NAME = 'UserRequestsStore';

export enum API_VARIABLES {
  REQUEST_ID = '{requestId}'
}

export const USER_REQUESTS_TABS= {
  USER_REQUESTS: 'USER_REQUESTS',
  APPROVED_HISTORY: 'APPROVED_HISTORY',
  DENIED_HISTORY: 'DENIED_HISTORY'
};

export const STATUS_TYPES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}

export const STATUS_ACTION_TYPES = {
  APPROVE: 'APPROVE',
  DENY: 'DENY'
}

export const ACTIONS = {
  GET_USER_REQUESTS_A: 'getUserRequestsA',
  RESPOND_USER_REQUESTS: 'respondUserRequestsA'
}

export const MUTATIONS = {
  SET_PENDING_USERS_M:'setPendingUsersM',
  SET_APPROVED_USERS_M:'setApprovedUsersM',
  SET_REJECTED_USERS_M:'setRejectedUsersM',
  RESET_USER_REQUESTS: 'resetUserRequestsM'
}

export const _USER_REQUESTS_STORE = {
  NAME: USER_REQUESTS_STORE_NAME,
  MUTATIONS: {
    SET_PENDING_USERS_M: `${USER_REQUESTS_STORE_NAME}/${MUTATIONS.SET_PENDING_USERS_M}`,
    SET_APPROVED_USERS_M: `${USER_REQUESTS_STORE_NAME}/${MUTATIONS.SET_APPROVED_USERS_M}`,
    SET_REJECTED_USERS_M: `${USER_REQUESTS_STORE_NAME}/${MUTATIONS.SET_REJECTED_USERS_M}`,
    RESET_USER_REQUESTS: `${USER_REQUESTS_STORE_NAME}/${MUTATIONS.RESET_USER_REQUESTS}`,
  },
  ACTIONS: {
    GET_USER_REQUESTS_A: `${USER_REQUESTS_STORE_NAME}/${ACTIONS.GET_USER_REQUESTS_A}`,
    RESPOND_USER_REQUESTS: `${USER_REQUESTS_STORE_NAME}/${ACTIONS.RESPOND_USER_REQUESTS}`,
  }
}

export const USER_REQUESTS_API = {
  USER_REQUESTS: 'register/admin/userRequest',
  GET_USER_REQUEST: 'register/admin/userRequest/{requestId}',
}